/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ApiQueue,
    ApiQueueFromJSON,
    ApiQueueFromJSONTyped,
    ApiQueueToJSON,
} from './ApiQueue';

/**
 * 
 * @export
 * @interface ApiQueueUpdateResponse
 */
export interface ApiQueueUpdateResponse {
    /**
     * 
     * @type {string}
     * @memberof ApiQueueUpdateResponse
     */
    error?: string;
    /**
     * 
     * @type {ApiQueue}
     * @memberof ApiQueueUpdateResponse
     */
    queue?: ApiQueue;
}

export function ApiQueueUpdateResponseFromJSON(json: any): ApiQueueUpdateResponse {
    return ApiQueueUpdateResponseFromJSONTyped(json, false);
}

export function ApiQueueUpdateResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiQueueUpdateResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'error': !exists(json, 'error') ? undefined : json['error'],
        'queue': !exists(json, 'queue') ? undefined : ApiQueueFromJSON(json['queue']),
    };
}

export function ApiQueueUpdateResponseToJSON(value?: ApiQueueUpdateResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'error': value.error,
        'queue': ApiQueueToJSON(value.queue),
    };
}

